export const LOCAL_STORAGE_CONFIG = { key:"BusaboutBookings" };


//COUNTRY PHONE NUMBERS
export const PHONE_NUMBERS = {
  USDCAD: ["+18776684328", "+1 877 668 4328"],
  GBPEUR: ["08082811114", "0808 281 1114"],
  AUD:["1300287226", "1300 287 226"],
  NZD:["0508287226", "0508 287 226"]
}


//CURRENCY FALLBACK
export const CURRENCY_FALLBACK = {iso_currency_code: "USD", currency: "Dollar", currency_mask: "$#,##0.00 "};


//MAP
export const MAPBOX_INDEX = "https://www.busabout.com/components/widgets/mapbox/index";
export const MAPBOX_INDEX_DEV = "/mapbox-products/src";


//POPULAR COUNTRIES LIST
export const POPULAR_COUNTRIES = [
  "Australia", "United States", "Canada", "United Kingdom", "New Zealand", "South Africa", "Germany", "France", "Poland", "Portugal"
];

//TIMEPASS - USA AND CAD
export const TIMEPASSCOUNTRY = ['USD', 'CAD'];
export const HOHOCODES = [
  {name:'Unlimited pass', tourID:'EIA'},
  {name:'Stop pass', tourID:'EJ2'},
  {name:'Timed pass', tourID:'ET4'}
];


//CREATE YOUR OWN ADVENTURE
export const CYOA_NETWORK_IDS = {
  "europe":{ id:"CYO", name:"europe"},
  "usa": { id: "CYU", name:"usa"}
}



//SLACKWEBHOOKS
export const SLACK_WEBHOOKS = {
  errors:"https://hooks.slack.com/services/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",
  confirmation:"https://hooks.slack.com/services/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"
}


//FUSE FUZZY OPTIONS
export const FUSE_OPTIONS = {
  shouldSort: true,
  tokenize: true,
  threshold: 0.3,
  location: 1,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 3,
  keys: ["name"]
}


//LOCKOUT MESSAGES
export const LOCKOUT_MESSAGES = {
  passengerDetailsTitle:'Last minute Booking Request',
  passengerDetailsText:'This tour is departing soon, therefore <a href="https://www.busabout.com/terms-conditions/last-minute-bookings" target="_blank" class="busabout--cta--link orange">Special Conditions Apply</a>. You can continue the booking process, but the booking will have to be confirmed by our sales agents once received. The amount to be paid will be pre-authorised on your card, but the funds will be taken from your account once our sales agent confirms availability of this product with you. <b>Please provide a correct telephone number below.</b>',
  bookingSummaryMeta:'<span class="hide-for-small-only"> |</span><span class="orange-text"> *</span> Special <a href="https://www.busabout.com/terms-conditions/last-minute-bookings" target="_blank" class="busabout--cta--link orange">Terms &amp; Conditions</a> apply to this booking.',
  bookingSummaryMetaCyoa:'Your accommodation bookings will have to be confirmed by our sales agents via email once received.' 
}



// WEBPACK FOOTER //
// ./src/config.js